import { PriceFinancial } from '@insurance/api/requests'
import { ConditionalText, DateTimeCell, Text } from '@shared/components'
import { getFormatCurrency } from '@shared/utils'
import { DescriptionsProps, Divider, Flex, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'
import { DetailsWrapper } from '../DetailsWrapper'
import { formProps } from './utils'

export const Details = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()
  const {
    priceKey,
    validFromProps,
    validToProps,
    priceDataKey,
    coefficientProps,
    personsCountProps,
    territoryProps
  } = formProps(t)

  const price = Form.useWatch(priceKey.name, { preserve: true })
  const validFrom = Form.useWatch(validFromProps.name, { preserve: true })
  const validTo = Form.useWatch(validToProps.name, { preserve: true })
  const territory = Form.useWatch(territoryProps.name, { preserve: true })
  const personsCount = Form.useWatch(personsCountProps.name, { preserve: true })
  const coefficient = Form.useWatch(coefficientProps.name, { preserve: true })
  const priceData = Form.useWatch(priceDataKey.name, { preserve: true }) as
    | PriceFinancial
    | undefined

  const items: DescriptionsProps['items'] = [
    {
      label: validFromProps.label,
      children: (
        <DateTimeCell
          date={validFrom}
          hiddenTime
          dateProps={{ className: styles.date }}
        />
      )
    },
    {
      label: validToProps.label,
      children: (
        <DateTimeCell
          date={validTo}
          hiddenTime
          dateProps={{ className: styles.date }}
        />
      )
    },
    {
      label: t('standard_premium'),
      children: (
        <ConditionalText
          condition={!!priceData?.data?.standard_prime}
          className={styles.text}
        >
          {getFormatCurrency({
            amount: priceData?.data?.standard_prime,
            currency: priceData?.currency
          })}
        </ConditionalText>
      )
    },
    {
      label: t('insured_sum'),
      children: (
        <ConditionalText
          condition={!!priceData?.data?.insured_sum}
          className={styles.text}
        >
          {getFormatCurrency({
            amount: priceData?.data?.insured_sum,
            currency: priceData?.currency
          })}
        </ConditionalText>
      )
    },
    {
      label: coefficientProps.label,
      children: (
        <ConditionalText condition={!!coefficient} className={styles.text}>
          {coefficient}
        </ConditionalText>
      )
    },
    {
      label: personsCountProps.label,
      children: (
        <ConditionalText condition={!!personsCount} className={styles.text}>
          {personsCount}
        </ConditionalText>
      )
    },
    {
      label: t('deductible'),
      children: (
        <ConditionalText
          condition={!!priceData?.data?.deductible_percent}
          className={styles.text}
        >
          {priceData?.data?.deductible_percent} %
        </ConditionalText>
      )
    },
    {
      label: territoryProps.label,
      children: (
        <ConditionalText condition={!!territory} className={styles.text}>
          {territory}
        </ConditionalText>
      )
    }
  ]

  return (
    <DetailsWrapper items={items}>
      {price && (
        <>
          <Flex align="center" justify="space-between">
            <Text strong size={18}>
              {t('total_to_be_paid')}
            </Text>
            <Text strong size={18} className="text-wrap-nowrap">
              {getFormatCurrency(price)}
            </Text>
          </Flex>

          <Divider />
        </>
      )}
    </DetailsWrapper>
  )
}
